import { useSelector } from 'src/store/store';

export function useIsLoggedIn() {
  const userId = useSelector(({ context }) => context.currentUser?.userId);
  return Boolean(userId);
}
